<template>
  <section class="section container">
    <div class="title is-3 has-text-centered">{{ $t("orders") }}</div>
    <div class="grid is-col-min-12">
      <div class="cell" @click="go_orders">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.freepik.com/256/2082/2082194.png?semt=ais_hybrid"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("orders") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="cell" @click="go_delivery">
        <div class="card">
          <div class="card-image">
            <figure class="image is-64x64 m-auto py-4">
              <img
                src="https://cdn-icons-png.flaticon.com/512/5457/5457799.png"
              />
            </figure>
          </div>
          <div class="card-content px-0">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ $t("delivery") }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { warning_message, get } from "@/utils";

export default {
  name: "AssistantIndex",
  components: {},
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    go_orders() {
      let v = this;
      v.$router.push({
        path: "/order/orders",
      });
    },
    go_delivery() {
      let v = this;
      v.$router.push({
        path: "/order/delivery",
      });
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped>
.grid .cell .card:hover {
  border-radius: 0.5em;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: linear 0.1s;
  transform: scale(1.05, 1.05);
}
.grid .cell .card:active {
  border-radius: 20px;
  box-shadow: 0px 0px 5px 1px rgba(0, 209, 178, 0.9);
  transition: ease-out 0.3s;
  transform: scale(1.5, 1.5);
  opacity: 0;
}

.grid .cell .card {
  background-color: rgba(20, 22, 26, 0.4);
}
</style>
